import { host } from "@wb/ui/analytics/host";
import type { Instance } from "@wb/ui/analytics/instances";
import { z } from "zod";

export const stateSchema = z.object({
  host: host.nullable(),
  enabled: z.boolean().optional(),
  debug: z.boolean().optional(),
  ga: z.boolean().optional(),
  clarity: z.boolean().optional(),
  posthog: z.boolean().optional(),
  vercel: z.boolean().optional(),
  cf: z.boolean().optional(),
  amplitude: z.boolean().optional(),
});

type State = z.infer<typeof stateSchema> & {
  instances: Instance[];
};

export const state: State = {
  host: null,
  enabled: true,
  debug: false,
  instances: [],
};
